import { commonStrings } from "./components/StringBundle";
import instance, { logoutDeviceOnce } from "./config/axios";
import { Cclmodule, apiRoutes, routes } from "./constants/routes";
import url from "./constants/url";

// import axios from 'axios'

// const headers ={
//     "Content-Type": 'application/json',
//     "Access-Control-Allow-Origin": "*"
// }

// Reads the refresh_token HttpOnly cookie server-side and sets a fresh
// access_token cookie — no tokens in the request or response body.
export const refreshAccessToken = () => {
  return instance
    .post(`${url.packagingapiurl}${Cclmodule.auth}/${apiRoutes.refresh}`)
    .then((res) => res);
};

// Logs out only this browser (Cognito RevokeToken), not the user's other devices.
export const logoutUserDevice = () => logoutDeviceOnce();

export const registerUser = (data) => {
  return instance
    .post(`${url.packagingapiurl}${Cclmodule.users}/${apiRoutes.create}`, data)
    .then((res) => {
      return res;
    });
};

export const updateUser = (data) => {
  return instance
    .put(`${url.packagingapiurl}${Cclmodule.users}/${apiRoutes.update}`, data)
    .then((res) => {
      return res;
    });
};
// export const CreatedUser = (data) => {
//     instance.post(`${url.apiGinUrl}${routes.CreatedUser}`, data)
//     .then(res => {
//         return res;
//     })
//     return instance.post(`${url.apiGinUrl}${routes.insertUser}`, data)
//     .then(res => {
//         return res;
//     })
// }

export const getUserPool = () => {
  return instance
    .get(`${url.apiGinUrl}${routes.listPoolUsers}`)
    .then((res) => {
      return res;
    })
    .catch((err) =>
      console.error("Error from get users list api", err?.message, err?.code)
    );
};

export const getUsers = () => {
  return instance
    .get(
      `${url.packagingapiurl}${Cclmodule.users}/${routes.grid}/${apiRoutes.info}`
    )
    .then((res) => {
      return res;
    })
    .catch((err) =>
      console.error("Error from get users list api", err?.message, err?.code)
    );
};
export const getUserInfo = () => {
  return instance
    .get(`${url.packagingapiurl}${Cclmodule.users}/${routes.getuserInfo}`)
    .then((res) => {
      return res;
    })
    .catch((err) =>
      console.error("Error from get users list api", err?.message, err?.code)
    );
};

export const changeUserStatus = (emailid) => {
  return instance
    .put(
      `${url.packagingapiurl}${Cclmodule.users}/${routes.userStatus}/${emailid}`
    )
    .then((res) => {
      return res;
    });
};

export const changeUserStatusDisable = (emailid) => {
  return instance
    .put(
      `${url.packagingapiurl}${Cclmodule.users}/${routes.userStatusDisable}/${emailid}`
    )
    .then((res) => {
      return res;
    });
};

export const changePassword = (data) => {
  return instance
    .put(
      `${url.packagingapiurl}${Cclmodule.users}/${routes.changePassword}/${apiRoutes.password}`,
      data
    )
    .then((res) => {
      return res;
    });
};

export const getLeads = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.leads}`, data)
    .then((res) => {
      return res;
    });
};

export const getAccounts = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.accounts}`, data)
    .then((res) => {
      return res;
    });
};
export const getContacts = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.contacts}`, data)
    .then((res) => {
      return res;
    });
};
export const getQuotes = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.quotes}`, data)
    .then((res) => {
      return res;
    });
};

export const getDivisionNames = (data) => {
  return instance
    .get(`${url.packagingapiurl}${routes.division}/${data}`)
    .then((res) => {
      return res;
    });
};

export const getCountryNames = (data = "") => {
  return instance
    .get(`${url.packagingapiurl}${routes.country}${data}`)
    .then((res) => {
      return res;
    });
};

export const getSupplierGroups = () => {
  return instance
    .get(`${url.packagingapiurl}${routes.getSupplierGroups}`)
    .then((res) => {
      return res;
    });
};

export const getStateNames = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.state}`, data)
    .then((res) => {
      return res;
    });
};

export const getCityNames = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.city}`, data)
    .then((res) => {
      return res;
    });
};

export const getProfileName = () => {
  return instance.get(`${url.apiGinUrl}${routes.profile}`).then((res) => {
    return res;
  });
};

export const convertLeadToAccount = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.convertLeadToAccount}`, data)
    .then((res) => {
      return res;
    });
};

export const getProductAndCategory = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.getProductAndCategory}`, data)
    .then((res) => {
      return res;
    });
};

export const getQuotesInfo = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.quotesInfo}`, data)
    .then((res) => {
      return res;
    });
};

// export const getQuotesInfo = (data) => {
//     return instance.post(`${url.packagingapiurl}${routes.quotesInfo}`, data)
//         .then(res => {
//             return res;
//         })
// }

export const createQuote = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.insertQuote}`, data)
    .then((res) => {
      return res;
    });
};

export const getSampleRequests = (params) => {
  return instance
    .post(`${url.packagingapiurl}${routes.sampleRequests}`, params)
    .then((res) => {
      return res;
    });
};

export const getAccountDetails = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.accountsDetail}`, data)
    .then((res) => {
      return res;
    });
};

export const getAccountPriceinfo = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.getAccountPriceinfo}`, data)
    .then((res) => {
      return res;
    });
};
//Packaging Release
export const createQuoteItemCustom = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.requestNewPackType}`, data)
    .then((res) => {
      return res;
    });
};

export const createAccountContact = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.accountContact}`, data)
    .then((res) => {
      return res;
    });
};

export const createAccountSample = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.accountSample}`, data)
    .then((res) => {
      return res;
    });
};

export const viewSampleRequest = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.viewSample}`, data)
    .then((res) => {
      return res;
    });
};

export const createSample = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.insertSample}`, data)
    .then((res) => {
      return res;
    });
};

export const getQuoteItems = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.getQuoteItems}`, data)
    .then((res) => {
      return res;
    });
};

export const getOrders = async (limit = 1000000000000000) => {
  return instance
    .get(`${url.packagingapiurl}${routes.getOrders}?limit=${limit}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error;
    });
};
export const getOrdersByID = async (id) => {
  return instance
    .get(`${url.packagingapiurl}${routes.getOrders}/${id}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrderInfoQuoteByLineQuoteID = async (id) => {
  return instance
    .get(`${url.packagingapiurl}${routes.getQuoteLineItemsByQuote}/${id}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrderLineItemByID = async (id) => {
  return instance
    .get(`${url.packagingapiurl}${routes.getOrderLineItem}/${id}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrdersLineItem = async (limit = 1000000000000000) => {
  return instance
    .get(`${url.packagingapiurl}${routes.getOrdersLineItem}?limit=${limit}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrderLineItemByOrder = async (id) => {
  return instance
    .get(`${url.packagingapiurl}${routes.getOrdersLineItem}/${id}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrdersDispatch = async (limit = 1000000000000000) => {
  return instance
    .get(`${url.packagingapiurl}${routes.getOrdersDispatch}?limit=${limit}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrderDispatchByID = async (id) => {
  return instance
    .get(`${url.packagingapiurl}${routes.getOrderDispatch}/${id}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error.response.data;
    });
};

export const getOrderDispatchByOrderLineItem = async (id) => {
  return instance
    .get(`${url.packagingapiurl}${routes.getOrdersDispatch}/${id}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error;
    });
};

export const getOrderDispatchesByOrder = async (id) => {
  return instance
    .get(`${url.packagingapiurl}${routes.getOrderDispatchesByOrder}/${id}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error;
    });
};

export const createOrder = async (obj) => {
  return instance
    .post(`${url.packagingapiurl}${routes.createOrder}`, obj,  {timeout: 5000000})
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error;
    });
};

export const updateOrder = async (json, id) => {
  return instance
    .put(`${url.packagingapiurl}${routes.updateOrder}/${id}`, json)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error.response.data;
    });
};
export const updateOrderLineItem = async (json, id) => {
  return instance
    .put(`${url.packagingapiurl}${routes.updateOrderLineItem}/${id}`, json)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error.response.data;
    });
};
export const updateOrderDispatch = async (json, id) => {
  return instance
    .put(`${url.packagingapiurl}${routes.updateOrderDispatch}/${id}`, json)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error.response.data;
    });
};

export const saveOrderDispatchDocuments = async (json, id) => {
  return instance
    .put(`${url.packagingapiurl}${routes.updateOrderDispatch}/${id}/documents`, json)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error.response.data;
    });
};

export const getDocumentsForDispatch = async (id) => {
  return instance
    .get(`${url.packagingapiurl}${routes.documentsForDispatch}/${id}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error.response.data;
    });
};

export const saveDocumentsForDispatch = async (obj) => {
  return instance
    .post(`${url.packagingapiurl}${routes.documentsForDispatch}`, obj)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error.response.data;
    });
};

export const downloadDocumentForDispatch = async (name) => {
  return instance
    .get(`${url.packagingapiurl}${routes.downloadDocumentForDispatch}/${name}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error.response.data;
    });
};

export const removeDocumentsForDispatch = async (id) => {
  return instance
    .delete(`${url.packagingapiurl}${routes.documentsForDispatch}/${id}`)
    .then((res) => {
      return res;
    })
    .catch((error) => {
      throw error.response.data;
    });
};

//Packaging Release
export const createQuoteItem = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.insertQuoteItem}`, data)
    .then((res) => {
      return res;
    });
};
export const updateQuoteItem = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.updateQuoteItem}`, data)
    .then((res) => {
      return res;
    });
};

export const updateQuoteStatus = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.updateQuoteStatus}`, data)
    .then((res) => {
      return res;
    });
};

// export const updateQuoteStatus = (data) => {
//     return instance.post(`${url.packagingapiurl}${routes.updateQuoteStatus}`, data)
//         .then(res => {
//             return res;
//         })
// }
//Packaging Release
export const getQuoteItemsInfo = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.quoteItemsInfo}`, data)
    .then((res) => {
      return res;
    });
};
export const getApprovedQuoteOnSampleId = (id) => {
  return instance
    .get(`${url.packagingapiurl}${Cclmodule.quotation}/${apiRoutes.approvedGcPrice}/${encodeURIComponent(id)}`)
    .then((res) => {
      return res;
    });
};
export const getAccountContacts = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.getAccountContacts}`, data)
    .then((res) => {
      return res;
    });
};

export const getAccountSamples = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.getAccountSamples}`, data)
    .then((res) => {
      return res;
    });
};

export const getAccountQuotes = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.getAccountQuotes}`, data)
    .then((res) => {
      return res;
    });
};

export const reassignAccount = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.reassignAccount}`, data)
    .then((res) => {
      return res;
    });
};
export const getQuotationInfo = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.quotesInfoErp}`, data)
    .then((res) => {
      return res;
    });
};

export const getQuoteItemSystemInfo = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.quoteItemSystemInfo}`, data)
    .then((res) => {
      return res;
    });
};

export const getQuoteItemSystemPackInfo = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.quoteItemSystemPackInfo}`, data)
    .then((res) => {
      return res;
    });
};
//Packaging Release
export const approveNewPackType = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.approveNewPackType}`, data)
    .then((res) => {
      return res;
    });
};
//Packaging Release
export const rejectNewPackType = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.rejectNewPackType}`, data)
    .then((res) => {
      return res;
    });
};
export const requestQuotePriceInfo = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.quoteRequestPrice}`, data)
    .then((res) => {
      return res;
    });
};

export const quoteSamples = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.quoteSamples}`, data)
    .then((res) => {
      return res;
    });
};

export const quoteSamplePricing = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.quoteSamplePricing}`, data)
    .then((res) => {
      return res;
    });
};

export const quoteRequestGCRates = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.quoteRequestGCRates}`, data)
    .then((res) => {
      return res;
    });
};

export const currencyConversion = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.currencyConversion}`, data)
    .then((res) => {
      return res;
    });
};

export const filterFixedContracts = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.filterFixedContracts}`, data)
    .then((res) => {
      return res;
    });
};

export const filterFixedContractsCustom = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.filterFixedContractsCustom}`, data)
    .then((res) => {
      return res;
    });
};

export const getFixedContractsByFields = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.getFixedContractsByFields}`, data)
    .then((res) => {
      return res;
    });
};



export const getGCApprovedQuotes = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.approvedQuotesOnGC}`, data)
    .then((res) => {
      return res;
    });
};

export const getTopMrinDetails = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.topMrin}`, data)
    .then((res) => {
      return res;
    });
};

// MRIN
export const getMRINs = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.getAllmrins}`, data)
    .then((res) => {
      return res;
    });
};
export const getMRINDetail = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.mrinDetails}`, data)
    .then((res) => {
      return res;
    });
};
export const submitMRINToQC = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.submitMRINToQC}`, data)
    .then((res) => {
      return res;
    });
};

export const createOrUpdateMRINDetail = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.createOrUpdateMrin}`, data)
    .then((res) => {
      return res;
    });
};
export const editMrinInformation = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.editMrinInformation}`, data)
    .then((res) => {
      return res;
    });
};
export const CloseButton = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.CloseButton}`, data)
    .then((res) => {
      return res;
    });
};
export const approveMRINByAccounts = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.approveMRINByAccounts}`, data)
    .then((res) => {
      return res;
    });
};
export const approveMRINByQC = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.approveMRINByQC}`, data)
    .then((res) => {
      return res;
    });
};

// get mring based on po no
export const getMrinListForPoDetails = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.getMrinListForPoView}`, data)
    .then((res) => {
      return res;
    });
};

export const updateVendorDetails = (data) => {
  return instance
    .put(`${url.packagingapiurl}${Cclmodule.vendor}/${apiRoutes.update}`, data)
    .then((res) => {
      return res;
    });
};

export const getVendorDetails = (id) => {
  return instance
    .get(
      `${url.packagingapiurl}${Cclmodule.vendor}/${
        apiRoutes.details
      }/${encodeURIComponent(id)}`
    )
    .then((res) => {
      return res;
    });
};

export const getVendorDispatchList = (id, company_name) => {
  return instance
    .get(
      `${url.packagingapiurl}${Cclmodule.vendor}/${apiRoutes.list}/${
        apiRoutes.dispatch
      }/${encodeURIComponent(id)}/${company_name}`
    )
    .then((res) => {
      return res;
    });
};

export const getVendorListPOByItem = (vendor_id, item_id) => {
  return instance
    .get(
      `${url.packagingapiurl}${Cclmodule.vendor}/${apiRoutes.list}/${apiRoutes.allpo}/${vendor_id}/${item_id}`
    )
    .then((res) => {
      return res;
    });
};

export const getVendorList = (company_name) => {
  return instance
    .get(`${url.packagingapiurl}${Cclmodule.vendor}/${apiRoutes.list}/${company_name}`)
    .then((res) => {
      return res;
    });
};

export const getVendorItemListByID = (id, company_name) => {
  return instance
    .get(
      `${url.packagingapiurl}${Cclmodule.vendor}/${apiRoutes.item}/${apiRoutes.list}/${id}/${company_name}`
    )
    .then((res) => {
      return res;
    });
};

export const fixedContracts = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.fixedContracts}`, data)
    .then((res) => {
      return res;
    });
};

export const editFixedContracts = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.editFixedContracts}`, data)
    .then((res) => {
      return res;
    });
};

// supplier
export const getSuppliers = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.getSuppliers}`, data)
    .then((res) => {
      return res;
    });
};

export const getSuppliersList = (data) => {
  return instance
    .get(`${url.packagingapiurl}${routes.curdSupplier}/${routes.grid}${data}`)
    .then((res) => {
      return res;
    });
};

export const createSupplier = (data) => {
  return instance
    .post(
      `${url.packagingapiurl}${routes.curdSupplier}/${routes.createSupplier}`,
      data
    )
    .then((res) => {
      return res;
    });
};
export const editSupplier = (data) => {
  return instance
    .put(
      `${url.packagingapiurl}${routes.curdSupplier}/${routes.updateSupplier}`,
      data
    )
    .then((res) => {
      return res;
    });
};

export const getDetailsSupplier = (id) => {
  return instance
    .get(
      `${url.packagingapiurl}${routes.curdSupplier}/${apiRoutes.details}/${id}`
    )
    .then((res) => {
      return res;
    });
};
export const getVendorPoQuantityDetails = (id) => {
  return instance
    .get(
      `${url.packagingapiurl}${routes.curdSupplier}/${apiRoutes.supplierpodetails}/${id}`
    )
    .then((res) => {
      return res;
    });
};
export const getVendorMrinQuantityDetails = (id) => {
  return instance
    .get(
      `${url.packagingapiurl}${routes.curdSupplier}/${apiRoutes.suppliermrindetails}/${id}`
    )
    .then((res) => {
      return res;
    });
};

export const getInfoSupplier = () => {
  return instance
    .get(`${url.packagingapiurl}${routes.curdSupplier}/${apiRoutes.forminfo}`)
    .then((res) => {
      return res;
    });
};

export const vendorLogin = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.vendorLogin}`, data)
    .then((res) => {
      return res;
    });
};

export const getGCDebitNoteCreationInfo = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.getGCDebitNoteCreationInfo}`, data)
    .then((res) => {
      return res;
    });
};

export const getlistGCDebitNoteDetails = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.listGCDebitNoteDetails}`, data)
    .then((res) => {
      return res;
    });
};

export const createDebitNote = (data) => {
  return instance
    .post(
      `${url.packagingapiurl}${routes.createDebitNote}/${apiRoutes.getcreate}`,
      data
    )
    .then((res) => {
      return res;
    });
};

export const updateDebitNote = (data) => {
  return instance
    .put(`${url.packagingapiurl}${routes.updateDebitNote}`, data)
    .then((res) => {
      return res;
    });
};

// export const updateDebitNoteStatus = (data) => {
//   return instance
//     .put(`${url.packagingapiurl}${routes.updateDebitNoteStatus}/${data.debitnoteid}`, data)
//     .then((res) => {
//       return res;
//     });
// }

export const getviewGCDebitNoteDetail = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.viewGCDebitNoteDetail}`, data)
    .then((res) => {
      return res;
    });
};

export const createorupdateSampleLineItem = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.createorupdateSampleLineItem}`, data)
    .then((res) => {
      return res;
    });
};

export const viewAndDeleteSampleLineItem = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.viewAndDeleteSampleLineItem}`, data)
    .then((res) => {
      return res;
    });
};

export const getNotifications = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.getNotifications}`, data)
    .then((res) => {
      return res;
    });
};
export const postNotification = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.postNotifications}`, data)
    .then((res) => {
      return res;
    });
};

export const updateMRINGCSpec = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.updateMRINGCSpec}`, data)
    .then((res) => {
      return res;
    });
};
export const sendMail = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.sendEmail}`, data)
    .then((res) => {
      return res;
    });
};
export const noReplyMail = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.noReplyMail}`, data)
    .then((res) => {
      return res;
    });
};
export const releaseDebitNoteGC = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.releaseDebitNote}`, data)
    .then((res) => {
      return res;
    });
};
export const CreateEditTaxMaster = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.taxMaster}`, data)
    .then((res) => {
      return res;
    });
};
export const getTaxes = (data) => {
  return instance
    .post(`${url.apiGinUrl}${routes.taxList}`, data)
    .then((res) => {
      return res;
    });
};
//Packaging Release
export const getAllPackingRequests = (params) => {
  return instance
    .post(`${url.packagingapiurl}${routes.getAllPackingRequests}`, params)
    .then((res) => {
      return res;
    });
};
//Packaging Release
export const viewPackingRequest = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.viewPackingRequest}`, data)
    .then((res) => {
      return res;
    });
};

export const getConversatioRatio = (data) => {
  //pricingGinUrl
  return instance
    .post(`${url.pricingapiurl}${routes.getConversatioRatio}`, data)
    .then((res) => {
      return res;
    });
};

export const getSamplesInfo = (data) => {
  //pricingGinUrl
  return instance
    .post(`${url.pricingapiurl}${routes.getSamplesInfo}`, data)
    .then((res) => {
      return res;
    });
};

export const insertPricingInfo = (data) => {
  //pricingGinUrl
  return instance
    .post(`${url.pricingapiurl}${routes.insertPricingInfo}`, data)
    .then((res) => {
      return res;
    });
};

export const updateSamplesInfoForPricing = (data) => {
  //pricingGinUrl
  return instance
    .post(`${url.pricingapiurl}${routes.updateSamplesInfoForPricing}`, data)
    .then((res) => {
      return res;
    });
};

export const getPackingInfoForPricing = (data) => {
  //pricingGinUrl
  return instance
    .post(`${url.pricingapiurl}${routes.getPackingInfoForPricing}`, data)
    .then((res) => {
      return res;
    });
};

export const getGCDataOnQuotes = (data) => {
  //pricingGinUrl
  return instance
    .post(`${url.pricingapiurl}${routes.getGCDataOnQuotes}`, data)
    .then((res) => {
      return res;
    });
};

export const getSelectedSamplesForPricing = (data) => {
  //pricingGinUrl
  return instance
    .post(`${url.pricingapiurl}${routes.getSelectedSamplesForPricing}`, data)
    .then((res) => {
      return res;
    });
};

export const updateQuotationStatusForPricing = (data) => {
  //pricingGinUrl
  return instance
    .post(`${url.pricingapiurl}${routes.updateQuotationStatusForPricing}`, data)
    .then((res) => {
      return res;
    });
};

export const updateGcPriceOnQuotes = (data) => {
  //pricingGinUrl
  return instance
    .post(`${url.pricingapiurl}${routes.updateGcPriceOnQuotes}`, data)
    .then((res) => {
      return res;
    });
};

export const getOtherFactorsInfo = (data) => {
  //pricingGinUrl
  return instance
    .post(`${url.pricingapiurl}${routes.getOtherFactorsInfo}`, data)
    .then((res) => {
      return res;
    });
};

export const updateOtherFactorsInfo = (data) => {
  //pricingGinUrl
  return instance
    .post(`${url.pricingapiurl}${routes.updateOtherFactorsInfo}`, data)
    .then((res) => {
      return res;
    });
};

export const getFinalisedSamples = (data) => {
  //pricingGinUrl
  return instance
    .post(`${url.pricingapiurl}${routes.getFinalisedSamples}`, data)
    .then((res) => {
      return res;
    });
};

export const updateConfirmSample = (data) => {
  //pricingGinUrl
  return instance
    .post(`${url.pricingapiurl}${routes.updateConfirmSample}`, data)
    .then((res) => {
      return res;
    });
};

export const getNewPackingRequests = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.getNewPackingRequests}`, data)
    .then((res) => {
      return res;
    });
};

export const createNewPackingType = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.createNewPackingType}`, data)
    .then((res) => {
      return res;
    });
};

export const getNewPackTypeCreationInfo = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.getNewPackTypeCreationInfo}`, data)
    .then((res) => {
      return res;
    });
};

export const viewNewPackingType = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.viewNewPackingType}`, data)
    .then((res) => {
      return res;
    });
};

export const updateNewPackingType = (data) => {
  return instance
    .post(`${url.packagingapiurl}${routes.updateNewPackingType}`, data)
    .then((res) => {
      return res;
    });
};

export const listMasterSamples = (data) => {
  return instance
    .get(`${url.sampleManagementApiUrl}${routes.listMasterSamples}`)
    .then((res) => {
      return res;
    });
};

export const listAlternativeSamples = () => {
  return instance
    .get(`${url.sampleManagementApiUrl}${routes.listAlternativeSamples}`)
    .then((res) => {
      return res;
    });
};

export const listCustomerSamples = (masterSampleId) => {
  return instance
    .get(
      `${url.sampleManagementApiUrl}${routes.masterSampleDetails}/${masterSampleId}/${routes.customerSampleByMasterSampleId}`
    )
    .then((res) => {
      return res;
    });
};

export const getMasterSampleDetails = (id) => {
  return instance
    .get(`${url.sampleManagementApiUrl}${routes.masterSampleDetails}/${id}`)
    .then((res) => {
      return res;
    });
};

export const deleteMasterSampleDetails = async (id) => {
  const res = await instance.delete(
    `${url.sampleManagementApiUrl}${routes.masterSampleDetails}/${id}`
  );
  return res;
};

export const createMasterSample = (data) => {
  return instance
    .post(`${url.sampleManagementApiUrl}${routes.masterSample}`, data)
    .then((res) => {
      return res;
    });
};

export const updateMasterSample = (data, id) => {
  return instance
    .put(`${url.sampleManagementApiUrl}${routes.masterSample}/${id}`, data)
    .then((res) => {
      return res;
    });
};

export const listAlternativeSamplesByMSId = (masterSampleId) => {
  return instance
    .get(
      `${url.sampleManagementApiUrl}${routes.masterSampleDetails}/${masterSampleId}/${routes.alternateSample}`
    )
    .then((res) => {
      return res;
    });
};

export const getAlternativeSampleDetails = (id) => {
  return instance
    .get(`${url.sampleManagementApiUrl}${routes.alternativeSample}/${id}`)
    .then((res) => {
      return res;
    });
};

export const deleteAlternativeSampleDetails = async (id) => {
  const res = await instance.delete(
    `${url.sampleManagementApiUrl}${routes.alternativeSample}/${id}`
  );
  return res;
};

export const listCustomerSamplesByASId = (id) => {
  return instance
    .get(
      `${url.sampleManagementApiUrl}${routes.alternativeSample}/${id}/${routes.customerSample}`
    )
    .then((res) => {
      return res;
    });
};

export const updateAlternativeSample = (data, id) => {
  return instance
    .put(`${url.sampleManagementApiUrl}${routes.alternativeSample}/${id}`, data)
    .then((res) => {
      return res;
    });
};

export const createAlternativeSample = (data) => {
  return instance
    .post(`${url.sampleManagementApiUrl}${routes.alternativeSample}`, data)
    .then((res) => {
      return res;
    });
};

export const getSampleItemDetails = () => {
  return instance
    .get(`${url.sampleManagementApiUrl}${routes.masterSampleItemDetails}`)
    .then((res) => {
      return res;
    });
};

export const getAllPackingTypeByCategoryId = (categoryId) => {
  return instance.post(
    url.packagingapiurl +
      "packing/getAllNamesByCategory?categoryId=" +
      categoryId
  );
};

export const createPackingType = (packingType) => {
  return instance.post(url.packagingapiurl + "packing/create", packingType);
};

export const updatePackingType = (packingType) => {
  return instance.post(url.packagingapiurl + "packing/update", packingType);
};

export const updatePackingTypeFromQLI = (packingType) => {
  return instance.post(
    url.packagingapiurl + "packing/updateFromQLI",
    packingType
  );
};

export const updatePackingTypeStatus = (packingType) => {
  return instance.post(
    url.packagingapiurl + "packing/updateStatus",
    packingType
  );
};

export const getAllPackingTypeByStatus = (status) => {
  return instance.post(
    url.packagingapiurl + "packing/getByStatus?status=" + status
  );
};

export const getPackingTypeDetails = (packingTypeId) => {
  return instance.post(url.packagingapiurl + "packing/get?id=" + packingTypeId);
};

export const getActivities = (packingId, type) => {
  return instance.post(
    url.packagingapiurl +
      "packing/getActivites?id=" +
      packingId +
      "&type=" +
      type
  );
};

export const getFieldValues = (fieldName) => {
  return instance.post(
    url.packagingapiurl + "packing/getUniqFieldValues?fieldName=" + fieldName
  );
};

export const getAllcategories = () => {
  return instance.post(url.packagingapiurl + "packing/getAllCategories");
};

export const updateStatus = (packingType) => {
  return instance.post(
    url.packagingapiurl + "packing/updateStatus",
    packingType
  );
};

export const getSampleOptions = () => {
  return instance
    .get(`${url.sampleManagementApiUrl}${routes.masterSampleOptions}`)
    .then((res) => {
      return res;
    });
};

export const getSampleParameters = () => {
  return instance
    .get(`${url.sampleManagementApiUrl}${routes.masterSampleParameters}`)
    .then((res) => {
      return res;
    });
};

export const getCustomerSampleInfo = async () => {
  const res = await instance.get(
    `${url.sampleManagementApiUrl}${routes.customerSampleInfo}`
  );
  return res;
};

export const getCustomerSamplesList = async () => {
  const res = await instance.get(
    `${url.sampleManagementApiUrl}${routes.customerSampleList}`
  );
  return res;
};

export const getCustomerSamplesListByME = async (username) => {
  const res = await instance.get(
    `${url.sampleManagementApiUrl}customersample/${username}/all`
  );
  return res;
};

export const getCustomerSampleDetails = async (id) => {
  const res = await instance.get(
    `${url.sampleManagementApiUrl}${routes.customerSampleDetails}/${id}`
  );
  return res;
};

export const deleteCustomerSampleDetails = async (id) => {
  const res = await instance.delete(
    `${url.sampleManagementApiUrl}${routes.customerSampleDetails}/${id}`
  );
  return res;
};

export const createCustomerSample = async (data) => {
  const res = await instance.post(
    `${url.sampleManagementApiUrl}${routes.customerSampleDetails}`,
    data
  );
  return res;
};

export const updateCustomerSample = async (data, id) => {
  const res = await instance.put(
    `${url.sampleManagementApiUrl}${routes.customerSampleDetails}/${id}`,
    data
  );
  return res;
};

export const getSamplePackingTypes = async () => {
  const res = await instance.get(
    `${url.sampleManagementApiUrl}${routes.packingTypes}`
  );
  return res;
};

export const createAttachment = async (data) => {
  const res = await instance.post(
    `${url.sampleManagementApiUrl}${routes.createAttachments}`,
    data
  );
  return res;
};

export const retrieveAttachment = async (data) => {
  const res = await instance.post(
    `${url.sampleManagementApiUrl}${routes.retrieveAttachments}`,
    data
  );
  return res;
};

export const createNotes = async (data) => {
  const res = await instance.post(
    `${url.sampleManagementApiUrl}${routes.createNotes}`,
    data
  );
  return res;
};

export const getNotesAttachments = async (requesttype,recordid,netsuiteId) => { 
  const res = await instance.get(
    `${url.packagingapiurl}${routes.getNotesAttachments}?request_type=${requesttype}&record_id=${recordid}&netsuite_id=${netsuiteId}`
  );
  return res;
};

export const retrieveNotes = async (data) => {
  const res = await instance.post(
    `${url.sampleManagementApiUrl}${routes.retrieveNotes}`,
    data
  );
  return res;
};

export const createAuditLogs = async (data) => {
  const res = await instance.post(
    `${url.sampleManagementApiUrl}${routes.createAuditLogs}`,
    data
  );
  return res;
};

export const retrieveAuditLogs = async (data) => {
  const res = await instance.post(
    `${url.sampleManagementApiUrl}${routes.retrieveAuditLogs}`,
    data
  );
  return res;
};



export const generateMasterSampleCode = async (data) => {
  const res = await instance.post(
    `${url.sampleManagementApiUrl}${routes.masterSampleCode}`,
    data
  );
  return res;
};

export const generateAlternativeSampleCode = async (data) => {
  const res = await instance.post(
    `${url.sampleManagementApiUrl}${routes.alternativeSampleCode}`,
    data
  );
  return res;
};

// export const getBlendSheetDetails1 = async (id) => {
//   const res = await instance.get(
//     `${url.blendSheetApiUrl}${routes.blendSheet}/${id}`
//   );
//   return res;
// };

// export const createBlendSheet1 = async (data) => {
//   const res = await instance.post(
//     `${url.blendSheetApiUrl}${routes.blendSheet}`,
//     data
//   );
//   return res;
// };
/** @param {import("./screens/admin/BlendSheet/types").BlendSheetSubmitPayload} data
 * @returns {Promise<{ batchNumber?: string; gcBlendSheetId?: string | number } | null>} */
export const createBlendSheet = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${routes.getBlendSheetCreate}`,
    data
  );
  return res;
};

// export const updateBlendSheet = async (data, id) => {
//   const res = await instance.put(
//     `${url.blendSheetApiUrl}${routes.blendSheet}/${id}`,
//     data
//   );
//   return res;
// };


// new po gin api functions
export const getPOFormInfo = async (type, company_name) => {
  let requestUrl = `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.getforminfo}?type=${type}`;
  if (type.includes("allsuppliers")) {
    requestUrl += `&company_name=${company_name}`;
  }
  const res = await instance.get(requestUrl);
  return res;
};

export const getCeationInfo = async (type) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.getcreationinfo}?type=${type}`
  );
  return res;
};
export const createPo = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.getcreate}`,
    payload
  );
  return res;
};
export const getGCPoDetails = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.getdetails}/${id}`
  );
  return res;
};
export const getGCDispatchDetails = async (payload) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.getdispatchdetails}`,
    payload
  );
  return res;
};

export const getgcPoDispatchDetails = async (id, item) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.getdispatchdetails}/${id}/item/${item}`
  );
  return res;
};

export const updateGCPODetails = async (payload) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.updateGCPODetails}`,
    payload
  );
  return res;
};

export const getdeleteGCPOAutoDispatch = async (id, pono) => {
  const res = await instance.delete(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.getdispatchdetails}/${id}/${pono}`
  );
  return res;
};
export const getpoDocumentsUpload = async (id) => {
  const res = await instance.delete(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.getpoDocumentsUpload}/${id}`
  );
  return res;
};
export const getpoDocumentsDownload = async (name) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.getpoDocumentsUpload}/${apiRoutes.getpoDocumentsDownload}/${name}`
  );
  return res;
};
export const getDocumentsDownload = async (name) => {
  const res = await instance.get(
    `${url.packagingapiurl}${apiRoutes.getDocumentDownload}/${name}`
  );
  return res;
};
export const getUploadDocument = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${apiRoutes.getUploadDocuments}`,
    payload
  );
  return res;
};
export const getpouploadDocument = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.getpoDocumentsUpload}`,
    payload
  );
  return res;
};
export const getpoupdatedocumentsInfo = async (payload) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.getpoDocumentsUpload}`,
    payload
  );
  return res;
};
export const getDocumentsOnPo = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.getpoDocumentsUpload}/${id}`
  );
  return res;
};
export const portAndOriginForPo = async (type) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.portAndOriginForPo}?type=${type}`
  );
  return res;
};
export const getBalQuote = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.getBalQuote}/${id}`
  );
  return res;
};
export const getupdateGcPoStatus = async (payload) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.getupdateGcPoStatus}`,
    payload
  );
  return res;
};
export const gettop3ApprovedPo = async (id, vendor_id, vendor_type) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.gettop3ApprovedPo}/${id}?vendor_id=${vendor_id}&vendor_type=${vendor_type}`
  );
  return res;
};
export const getTopMRIN = async (id, date) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.gettopmrin}/${id}?date=${date}`
  );
  return res;
};
export const getaddothercharges = async (payload) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.updateGCPODetails}/${apiRoutes.getaddothercharges}`,
    payload
  );
  return res;
};
export const getupdatePrice = async (payload) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.purchaseOrder}/${apiRoutes.updateGCPODetails}/${apiRoutes.getupdatePrice}`,
    payload
  );
  return res;
};
export const getMRINLIST = async (id, date) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.MRIN}/${
      apiRoutes.getmrinlist
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getMrindetails = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.MRIN}/${
      apiRoutes.getdetails
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getMrindocumentdownload = async (name) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.MRIN}/${apiRoutes.document}/${
      apiRoutes.getpoDocumentsDownload
    }/${encodeURIComponent(name)}`
  );
  return res;
};
export const otherSpecification = async (id, data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.MRIN}/${
      apiRoutes.otherSpecification
    }/${encodeURIComponent(id)}`,
    data
  );
  return res;
};
export const topmrindetails = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.MRIN}/${
      apiRoutes.topMrinDetails
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getmrinpoview = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.MRIN}/${apiRoutes.po}/${
      apiRoutes.view
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getmrinpoDispatch = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.MRIN}/${apiRoutes.po}/${
      apiRoutes.dispatchMRIN
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getupdatemrin = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.MRIN}/${apiRoutes.updateGCPODetails}`,
    data
  );
  return res;
};
export const getmrinpayment = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.MRIN}/${apiRoutes.payment}`,
    payload
  );
  return res;
};
export const getmrindocument = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.MRIN}/${apiRoutes.document}`,
    payload
  );
  return res;
};
export const createmrin = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.MRIN}/${apiRoutes.getcreate}`,
    payload
  );
  return res;
};
export const deletemrindocument = async (filename) => {
  const res = await instance.delete(
    `${url.packagingapiurl}${Cclmodule.MRIN}/${
      apiRoutes.document
    }${encodeURIComponent(filename)}`
  );
  return res;
};
export const addressbilling = async (contact_id, account_id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.address}/${
      apiRoutes.billingonly
    }?contact_id=${encodeURIComponent(contact_id)}&account_id=${account_id}`
  );
  return res;
};
export const addressshipping = async (contact_id, account_id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.address}/${
      apiRoutes.shippingonly
    }?contact_id=${encodeURIComponent(contact_id)}&account_id=${account_id}`
  );
  return res;
};
export const quotecurrencies = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.currencies}`
  );
  return res;
};
export const quoteincoterms = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.incoterms}`
  );
  return res;
};
export const quoteaccountquotation = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.accountquotation}`,
    payload
  );
  return res;
};
export const quoteaccountsample = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.sampleaccount}`,
    payload
  );
  return res;
};
export const quotelineclone = async (id, companyName) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.line}/${
      apiRoutes.clone
    }/${encodeURIComponent(id)}/${companyName}`
  );
  return res;
};
export const quoteline = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quote}/${
      apiRoutes.line
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getportdestination = async (code) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.ports}/${apiRoutes.destination}`
  );
  return res;
};


/**@returns {Promise<DestinationPortEntry[]>} */
export const getDestinationPortsList = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${apiRoutes.common}/${apiRoutes.destinationPortsList}`,
  );
  return res;
};

export const getportloading = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.ports}/${apiRoutes.loading}`
  );
  return res;
};
export const getstatuses = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.statuses}`
  );
  return res;
};

export const viewdebitnote = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.debitnote}/${
      apiRoutes.getdetails
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getGCDebitNoteCreationinfo = async (companyName) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.debitnote}/${apiRoutes.getGCDebitNoteCreationinfo}/${companyName}`
  );
  return res;
};
export const mrinsOnVendor = async (entity_id, vendor_id, debit_notedate) => { 
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.debitnote}/${
      apiRoutes.getmrinonvendor
    }/${encodeURIComponent(entity_id)}/${encodeURIComponent(
      vendor_id
    )}/${encodeURIComponent(debit_notedate)}`
  );
  return res;
};
export const updateDebitNoteStatus = async (id, data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.debitnote}/${
      apiRoutes.updateDebitNoteStatus
    }/${encodeURIComponent(id)}`,
    data
  );
  return res;
};
export const getquoteid = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quote}/${encodeURIComponent(id)}`
  );
  return res;
};
export const getquotapprovedlistid = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quote}/${
      apiRoutes.approvedlist
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getquotallpackingsubtype = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quote}/${
      apiRoutes.getallpackingsubtypes
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getallpackingtypes = async (id, subType) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quote}/${
      apiRoutes.getallpackingtypes
    }/${encodeURIComponent(id)}/${subType}`
  );
  return res;
}
export const getcreatequote = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.getcreate}`,
    payload
  );
  return res;
};

export const onRejectQuoteMD = (data) => {
  return instance
    .put(
      `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.line}/${apiRoutes.reject}/${apiRoutes.md}`,
      data
    )
    .then((res) => {
      return res;
    });
};

export const getupdatequote = (data) => {
  return instance
    .put(
      `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.updateGCPODetails}`,
      data
    )
    .then((res) => {
      return res;
    });
};
export const getquotelineapproved = async (date, item_id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.line}/${
      apiRoutes.approved
    }?date=${encodeURIComponent(date)}&item_id=${encodeURIComponent(item_id)}`
  );
  return res;
};
export const getupdatestatus = (data) => {
  return instance
    .put(
      `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.updateGCPODetails}/${apiRoutes.getupdateGcPoStatus}`,
      data
    )
    .then((res) => {
      return res;
    });
};
export const getquotelinepackingcategories = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.line}/${apiRoutes.packing}/${apiRoutes.categories}`
  );
  return res;
};
export const getquotelinecreate = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.line}/${apiRoutes.getcreate}`,
    data
  );
  return res;
};
export const getquotelineupdate = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.line}/${apiRoutes.updateGCPODetails}`,
    data
  );
  return res;
};

export const getquotelineupdateinfo = (data) => {
  return instance
    .put(
      `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.line}/${apiRoutes.updateGCPODetails}/${apiRoutes.info}`,
      data
    )
    .then((res) => {
      return res;
    });
};

export const approvenetsuiteBlendSheet = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.blendsheet}/${apiRoutes.process}/${encodeURIComponent(id)}`
  );
  return res;
};

export const getAllSoftSchedulingOrders = async (filter) => {
  // /order/dispatch/schedules?date=all
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.order}/${apiRoutes.getdispatchdetails}/${apiRoutes.schedules}?date=${filter}`
  );
  return res;
};
export const getAllSoftSchedulingByOrderDispatch = async (id) => {
  // /order/dispatch/schedules?date=all
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.order}/${apiRoutes.getdispatchdetails}/${apiRoutes.schedules}/${id}`
  );
  return res;
};
export const getAllSoftSchedulingByOrderLine = async (id) => {
  // /order/dispatch/schedules?date=all
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.order}/${apiRoutes.getlinedetails}/${apiRoutes.schedules}/${id}`
  );
  return res;
};
export const getAllSoftSchedulingByOrder = async (id) => {
  // /order/dispatch/schedules?date=all
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.order}/${apiRoutes.schedules}/${id}`
  );
  return res;
};

//   leads start
export const getleadscontact = async (name) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.leads}/${apiRoutes.contacts}?name=${name}`
  );
  return res;
};
export const getleadslist = async (status) => {
  const res = await instance.get(
    //status=${status}&created_by=${created_by}
    `${url.packagingapiurl}${Cclmodule.leads}/${apiRoutes.list}?${status}`
  );
  return res;
};
export const getcreatelead = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.leads}/${apiRoutes.getcreate}`,
    payload
  );
  return res;
};
export const Leadsdetails = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.leads}/${
      apiRoutes.getdetails
    }/${encodeURIComponent(id)}`
  );
  return res;
};

export const getLeadsinfoaccounts = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.leads}/${apiRoutes.info}/${apiRoutes.accounts}`
  );
  return res;
};
export const getLeadsinfocodes = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.leads}/${apiRoutes.info}/${apiRoutes.codes}`
  );
  return res;
};
export const getLeadsinfocoffee = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.leads}/${apiRoutes.info}/${apiRoutes.coffee}`
  );
  return res;
};
export const getLeadsinfocountries = async (continent) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.leads}/${apiRoutes.info}/${apiRoutes.countries}?continent=${continent}`
  );
  return res;
};
export const getLeadsinfoproducts = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.leads}/${apiRoutes.info}/${apiRoutes.products}`
  );
  return res;
};
export const getLeadsinfosalutation = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.leads}/${apiRoutes.info}/${apiRoutes.salutation}`
  );
  return res;
};
export const getleadsreassign = (data) => {
  return instance
    .put(`${url.packagingapiurl}${Cclmodule.leads}/${apiRoutes.reassign}`, data)
    .then((res) => {
      return res;
    });
};
export const getleadsupdate = (data) => {
  return instance
    .put(`${url.packagingapiurl}${Cclmodule.leads}/${apiRoutes.update}`, data)
    .then((res) => {
      return res;
    });
};

//   lead end
export const getAllSoftSchedulingByCST = async (qli_no) => {
  // /order/dispatch/schedules?date=all
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.order}/${apiRoutes.getdispatchdetails}/${apiRoutes.schedules}/${apiRoutes.calendar}?quote_line_id=${qli_no}`
  );
  return res;
};

export const newOrderSchedule = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.order}/${apiRoutes.schedule}`,
    data
  );
  return res;
};

export const getDetailsBySoftScheduleForDispatch = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.order}/${apiRoutes.dispatch}/${apiRoutes.schedule}/${apiRoutes.detail}/${id}`
  );
  return res;
};
export const getpackingquotelineupdate = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${apiRoutes.packing}/${apiRoutes.quoteline}/${apiRoutes.update}`,
    data
  );
  return res;
};
export const getpackinglistnaturalpoly = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.packing}/${apiRoutes.listnaturalpoly}/${commonStrings.ccl}`
  );
  return res;
};
//gc start

export const getgccreate = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.gc}/${apiRoutes.getcreate}`,
    data
  );
  return res;
};

export const getgcitemdetails = async (id,company) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gc}/${
      apiRoutes.getdetails
    }/${encodeURIComponent(id)}?company_name=${company}`
  );
  return res;
};
export const getItemPoDetails = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gc}/${
      apiRoutes.itempodetails
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getItemMrindetails = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gc}/${
      apiRoutes.itemmrindetails
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getgcitemforminfo = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gc}/${apiRoutes.frominfo}`
  );
  return res;
};

// get UOM list
export const getUOMList = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gc}/${apiRoutes.gcUOMList}`
  );
  return res;
};

export const getgcupdate = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.gc}/${apiRoutes.update}`,
    data
  );
  return res;
};
//gc complete

// account start
export const getaccountpricing = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.pricing}`,
    data
  );
  return res;
};
export const getaccountpricingid = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.account}/${
      apiRoutes.pricing
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getaccountcontctlist = async (data) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.contact}/${apiRoutes.list}?${data}` //&created_by=${created_by}
  );
  return res;
};
export const getaccountreassign = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.reassigng}`,
    data
  );
  return res;
};
export const getaccountquote = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.account}/${
      apiRoutes.quotes
    }/${encodeURIComponent(id)}`
  );
  return res;
};

export const getaccountleadapproveconvertreject = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.lead}/${apiRoutes.approve}`,
    data
  );
  return res;
};
export const getaccountlist = async (status) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.list}${status}`
  );
  return res;
};
export const getaccountcontact = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.contact}`,
    data
  );
  return res;
};
export const getaccountcontactpost = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.contact}`,
    data
  );
  return res;
};

export const getaccountcontactbilling = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.contact}/${apiRoutes.billing}`,
    data
  );
  return res;
};
export const getaccountcontactbillingpost = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.contact}/${apiRoutes.billing}`,
    data
  );
  return res;
};
export const getaccountcontactbillingid = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.contact}/${
      apiRoutes.billing
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getaccountcontactdetails = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.contact}/${
      apiRoutes.details
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getaccountcontactshipping = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.contact}/${apiRoutes.shipping}`,
    data
  );
  return res;
};
export const getaccountcontactshippingput = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.contact}/${apiRoutes.shipping}`,
    data
  );
  return res;
};
export const getaccountcontactshippingid = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.contact}/${apiRoutes.shipping}/${encodeURIComponent(id)}`
  )
  return res;
};
export const getaccountdetailsid = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.account}/${
      apiRoutes.details
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getaccountupdate = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.update}`,
    data
  );
  return res;
};
export const getaccountcontactinfo = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.contact}/${
      apiRoutes.info
    }/${encodeURIComponent(id)}`
  );
  return res;
};

// certification
export const getCertificationDetailsList = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.certification}/${apiRoutes.form}/${apiRoutes.details}`
  );
  return res;
};
export const getcertificationcreate = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.certification}/${apiRoutes.create}`,
    data
  );
  return res;
};
export const getcertificationbodycreate = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.certification}/${apiRoutes.body}/${apiRoutes.create}`,
    data
  );
  return res;
};
export const getCertificationgrid = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.certification}/${apiRoutes.grid}`
  );
  return res;
};
export const getcertificateupdate = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.certification}/${apiRoutes.update}`,
    data
  );
  return res;
};
export const getcertificatedetails = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.certification}/${
      apiRoutes.details
    }/${encodeURIComponent(id)}`
  );
  return res;
};

//notification
export const getcreatenotification = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.notification}/${apiRoutes.create}`,
    data
  );
  return res;
};
// production cost
export const getupdateproductioncost = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.productioncost}/${apiRoutes.otherfactors}/${apiRoutes.update}`,
    data
  );
  return res;
};
export const getupdateProductionOtherFactorsInfo = async (data) => {
  const res = await instance.post(
    `${url.pricingapiurl}${apiRoutes.OtherFactorsInfo}`,
    data
  );
  return res;
};

export const getAlternateSamplesid = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.samples}/${
      apiRoutes.alternateSamples
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getcustomerSamplesid = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.samples}/${
      apiRoutes.customersamples
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getmasterSamplesid = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.samples}/${
      apiRoutes.mastersamples
    }/${encodeURIComponent(id)}`
  );
  return res;
};

export const getcreatetax = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.taxes}/${apiRoutes.create}`,
    data
  );
  return res;
};
export const gettaxesdetailsid = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.taxes}/${
      apiRoutes.getdetails
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const gettaxesgrid = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.taxes}/${apiRoutes.grid}`
  );
  return res;
};

export const gettaxesupdate = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.taxes}/${apiRoutes.updateGCPODetails}`,
    data
  );
  return res;
};

export const getgcallocationgrid = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gcallocationgrid}/${apiRoutes.gridgcallocation}`
  );
  return res;
};
export const getgcallocationdetails = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gcallocationgrid}/${
      apiRoutes.View
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getgcallocationupdate = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.gcallocationgrid}/${apiRoutes.updategcallocation}`,
    data
  );
  return res;
};
export const getcreateallocation = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.gcallocationgrid}/${apiRoutes.createallocation}`,
    data
  );
  return res;
};
export const getgcallocationquoteview = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gcallocationgrid}/${
      apiRoutes.quoteview
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getgcquotequantityitem = async (payload) => {
  const res = await instance.post(`${url.packagingapiurl}${Cclmodule.gcallocationgrid}/${apiRoutes.quotequantityitem}`, payload);
  return res;
};
export const getgcpoview = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gcallocationgrid}/${
      apiRoutes.poview
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getsamplereport = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.reports}/${apiRoutes.samplereport}`
  );
  return res;
};
export const getgcallocationitemview = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gcallocationgrid}/${
      apiRoutes.itemview
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getaccountallocationitemview = async (id) => {
  const res = await instance.get(`${url.packagingapiurl}${Cclmodule.gcallocationgrid}/${apiRoutes.accountgrid}/${id}`);
  return res;
};
export const getvendordispatchgrid = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.vendor}/${apiRoutes.dispatchgrid}`
  );
  return res;
};
export const getAllocatedQuantityPO = async (pono) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gcallocationgrid}/${
      apiRoutes.allocatedpoqty
    }/${encodeURIComponent(pono)}`
  );
  return res;
};
export const getPlantCapacity = async (name, filter) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.order}/${apiRoutes.schedule}/${apiRoutes.plantcapacity}/${name}/${filter}`
  );
  return res;
};
export const getaccountcustomergride = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.account}/${
      apiRoutes.customersamplegride
    }/${encodeURIComponent(id)}`
  );
  return res;
};
export const getaccountwithcustomersamplewithoutquote = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.accountwithcustomersamplewithoutquote}`
  );
  return res;
};
export const getaccountwithquotewithoutcustomersample = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.accountwithquotewithoutcustomersample}`
  );
  return res;
};
export const getinactiveaccount = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.inactiveaccount}`
  );
  return res;
};

export const getPPCPlanning = async (limit = 10000000, orderId = null, orderLineId = null) => {
  // Start building the query parameters string
  let queryParams = `?limit=${limit}`;

  // Add orderId if present
  if (orderId) {
    queryParams += `&orderId=${orderId}`;
  }

  // Add orderLineId if present
  if (orderLineId) {
    queryParams += `&orderLineId=${orderLineId}`;
  }

  // Make the API call with the query parameters
  const res = await instance.get(
    `${url.packagingapiurl}${routes.getOrderDispatchPPCPlanning}${queryParams}`
  );

  return res;
};


export const getPackingUnits = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${routes.getOrderDispatchPackingUnits}`
  );
  return res;
};

export const getgcinventory = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.gcinventory}/${apiRoutes.getgcinventory}`,
    data
  );
  return res;
};
export const getgcinventoryitemwisequote = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.gcinventory}/${apiRoutes.getgcinventoryquote}`,
    data
  );
  return res;
};
export const getordersyncatednetsuitid = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.order}/${apiRoutes.syncnetsuite}/${encodeURIComponent(id)}`
  );
  return res;

};

export const checkInvoiceNumberExists = async (invoiceNumber) => {
   const res = await instance.get(`${url.packagingapiurl}${Cclmodule.logisticCosts}/${routes.checkInvoiceNumberExists}/${encodeURIComponent(invoiceNumber)}`);
  return res;
};

export const getsamplerequestgrid = async (data) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.samplerequest}/${apiRoutes.grid}${data}`
  );
  return res;
};
export const getcreatesamplerequest = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.samplerequest}/${apiRoutes.createsamplerequest}`,
    data
  );
  return res;
};
export const getorderbom = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.order}/${apiRoutes.bominfo}`,
    data
  );
  return res;
};
export const getsamplerequestview = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.samplerequest}/${apiRoutes.SampleRequestview}/${encodeURIComponent(id)}`
  );
  return res;
};
export const getsamplerequeststatus = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.samplerequest}/${apiRoutes.samplerequeststatus}`
  );
  return res;
};
export const getupdatesamplerequest = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.samplerequest}/${apiRoutes.updatesamplerequest}`,
    data
  );
  return res;
};
export const getsamplelinerequestgrid = async (data) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.samplerequest}/${apiRoutes.gridsampleline}/${data}`
  );
  return res;
};
export const getsamplerequestlistofvalues = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.samplerequest}/${apiRoutes.listofvalues}`
  );
  return res;
};
export const getsamplelinerequestview = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.samplerequest}/${apiRoutes.SamplelineRequestview}/${encodeURIComponent(id)}`
  );
  return res;
};
export const getcreatesamplelinerequest = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.samplerequest}/${apiRoutes.createsampleline}`,
    data
  );
  return res;
};
export const getupdatesamplelinerequest = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.samplerequest}/${apiRoutes.updatesampleline}`,
    data
  );
  return res;
};
export const getupdatesamplelinerequestrd = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.samplerequest}/${apiRoutes.updatesamplelinerd}`,
    data
  );
  return res;
};
export const getsamplerequeststatusupdate = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.samplerequest}/${apiRoutes.statusupdate}`,
    data
  );
  return res;
};
export const getsamplelinerequestcustomerfeedback = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.samplerequest}/${apiRoutes.customerfeedback}/${encodeURIComponent(id)}`
  );
  return res;
};
export const getaccountsampleinfoid = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.account}/${apiRoutes.sample}/${apiRoutes.info}/${encodeURIComponent(id)}`
  );
  return res;
};
export const getquoteupdatebom = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.quote}/${apiRoutes.quotebom}`,
    data
  );
  return res;
};
export const getgcdailyaegrid = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gcdailyrate}/${apiRoutes.gridgcrates}`
  );
  return res;
};
export const getgcdailyconvertionrate = async (date) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gcdailyrate}/${apiRoutes.convertionrate}/${encodeURIComponent(date)}`
  );
  return res;
};
export const getcreategcdailyrates = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.gcdailyrate}/${apiRoutes.creategcrates}`,
    data
  );
  return res;
};
export const getgcdailyaeview = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gcdailyrate}/${apiRoutes.viewgcdailyrates}/${encodeURIComponent(id)}`
  );
  return res;
};
export const getgcdailyrateupdate = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.gcdailyrate}/${apiRoutes.updategcdailyrates}`,
    data
  );
  return res;
};
export const getgcenquirygrid = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gcenquiry}/${apiRoutes.gcenquirygrid}`
  );
  return res;
};
export const getgcenquirylistvendor = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gcenquiry}/${apiRoutes.listvendor}`
  );
  return res;
};
export const getgcenquirylistitem = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gcenquiry}/${apiRoutes.listitem}`
  );
  return res;
};
export const getgcenquirygridItem = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gcenquiry}/${apiRoutes.gcenquirygriditem}/${id}`    
  );
  return res;
};
export const getcreategcenquiry = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.gcenquiry}/${apiRoutes.creategcenquiry}`,
    data
  );
  return res;
};
export const getgcenquiryview = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gcenquiry}/${apiRoutes.viewgcenquiry}/${encodeURIComponent(id)}`
  );
  return res;
};
export const getgcenquiryupdate = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.gcenquiry}/${apiRoutes.updategcenquiry}`,
    data
  );
  return res;
};
export const getgcdailyrateslistitem = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gcdailyrate}/${apiRoutes.gcdailyrateitemlist}`
  );
  return res;
};
export const getgcdailyrategriditem = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.gcdailyrate}/${apiRoutes.gcdailyratedbyitem}/${encodeURIComponent(id)}`
  );
  return res;
};

export const getauditreportgcinformation = async (payload) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.auditreport}/${apiRoutes.gcinformation}?${payload}`
  );
  return res;
};
export const getauditreportviewpicklist = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.auditreport}/${apiRoutes.viewpicklist}`
  );
  return res;
};


export const orderDispatchUpdate = async (odn) => {
  const res = await instance.get(
   `${url.packagingapiurl}${Cclmodule.order}/${apiRoutes.getdispatchdetails}/${apiRoutes.validate}?order_dispatch_number=${odn}`,
  );
  return res;
};


export const createBatchOutput = (data) => {
  return instance
    .post(`${url.packagingapiurl}${apiRoutes.batchoutput}${apiRoutes.createBatchOutput}`, data)
    .then((res) => {
      return res;
    });
};
export const updateBatchOutput = (data) => {
  return instance
    .put(`${url.packagingapiurl}${apiRoutes.batchoutput}${apiRoutes.updateBatchOutput}`, data)
    .then((res) => {
      return res;
    });
};
export const listBatchOutputs = () => {
  console.log(url.packagingapiurl);
  return instance
    .get(`${url.packagingapiurl}${apiRoutes.batchoutput}${apiRoutes.listBatchOutputs}`)
    .then((res) => {
      return res;
    });
};
export const listAlternativeSampleBatchOutputs = (alternativeSampleId) => {
  console.log(url.packagingapiurl);
  return instance
    .get(`${url.packagingapiurl}${apiRoutes.batchoutput}${apiRoutes.listAlternativeSampleBatchOutputs}/${alternativeSampleId}`)
    .then((res) => {
      return res;
    });
};
export const AlternativeSampleDetails = (sampleId) => {
  console.log(url.packagingapiurl);
  return instance
    .get(`${url.packagingapiurl}${apiRoutes.batchoutput}${apiRoutes.alternativeSampleDetails}/${sampleId}`)
    .then((res) => {
      return res;
    });
};

export const listCustomerSampleBatchOutputs = (accountId) => {
  console.log(url.packagingapiurl);
  return instance
    .get(`${url.packagingapiurl}${apiRoutes.batchoutput}${apiRoutes.listCustomerSampleBatchOutputs}/${accountId}`)
    .then((res) => {
      return res;
    });
};
export const GetAllAlternativeSamples = (companyName) => {
  console.log(url.packagingapiurl);
  return instance
    .get(`${url.packagingapiurl}${apiRoutes.batchoutput}${apiRoutes.GetAllAlternativeSamples}/${companyName}`)
    .then((res) => {
      return res;
    });
};

export const getquotationquotestatus = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quotation}/${apiRoutes.quotestatus}`
  );
  return res;
};
export const getquotationgrid = async (payload) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.quotation}/${apiRoutes.quotegrid}`, payload
  );
  return res;
};
export const getcreatequotation = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.quotation}/${apiRoutes.createquote}`,
    data
  );
  return res;
};
export const getquotationview = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quotation}/${apiRoutes.viewquote}/${encodeURIComponent(id)}`
  );
  return res;
};
export const getcreatequotationine = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.quotation}/${apiRoutes.createquoteneline}`,
    data
  );
  return res;
};
export const getquotationlineview = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quotation}/${apiRoutes.viewquotationline}/${encodeURIComponent(id)}`
  );
  return res;
};
export const getquotationlinegrid = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quotation}/${apiRoutes.quotelinegrid}/${encodeURIComponent(id)}`
  );
  return res;
};
export const getupdatestatusquotation = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.quotation}/${apiRoutes.updatequotestatus}`,
    data
  );
  return res;
};
export const getupdatequotepricingstatus = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.quotation}/${apiRoutes.updatequotepricingstatus}`,
    data
  );
  return res;
};
export const getprisingfinalizesample = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.pricing}/${apiRoutes.getfinalizedsampleinfo}`,
    data
  );
  return res;
};
export const updatefinalizedsample = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.pricing}/${apiRoutes.updatefinalizedsample}`,
    data
  );
  return res;
};
export const getpricinggcdataonquotes = async (quote_item_id,quote_id) => {
  const res = await instance.get(
    // `${url.packagingapiurl}${Cclmodule.pricing}/${apiRoutes.getgcdataonquotes}/${encodeURIComponent(quote_item_id)}/${encodeURIComponent(
      // quote_id
    // )}`
    `${url.packagingapiurl}${Cclmodule.pricing}/${
      apiRoutes.getgcdataonquotes
    }/${encodeURIComponent(quote_item_id)}/${encodeURIComponent(
      quote_id
    )}`
  );
  return res;
};
export const getpricingotherfactorsinfo = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.pricing}/${apiRoutes.getotherfactorsinfo}/${encodeURIComponent(id)}`
  );
  return res;
};
export const getpricingpackinginfopricing = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.pricing}/${apiRoutes.getpackinginfopricing}/${encodeURIComponent(id)}`
  );
  return res;
};
export const getpricingsamplesinfo = async (id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.pricing}/${apiRoutes.getsamplesinfo}/${encodeURIComponent(id)}`
  );
  return res;
};
export const getinsertprisinginfo = async (data) => {
  const res = await instance.post(
    `${url.packagingapiurl}${Cclmodule.pricing}/${apiRoutes.insertpricinginfo}`,
    data
  );
  return res;
};
export const getselectedsampleprincinginfo = async (quote_id, quote_line_id) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.pricing}/${
      apiRoutes.selectedsampleprincinginfo
    }/${encodeURIComponent(quote_id)}/${encodeURIComponent(
      quote_line_id
    )}`
  );
  return res;
};
export const getupdateconfirmedsample = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.pricing}/${apiRoutes.updateconfirmedsample}`,
    data
  );
  return res;
};
export const getupdategcprice = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.pricing}/${apiRoutes.updategcprice}`,
    data
  );
  return res;
};
export const getupdateotherfactors = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.pricing}/${apiRoutes.updateotherfactors}`,
    data
  );
  return res;
};
export const getupdateproductionotherfactors = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.pricing}/${apiRoutes.updateproductionotherfactors}`,
    data
  );
  return res;
};
export const getupdatestatuslog = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.pricing}/${apiRoutes.updatestatuslog}`,
    data
  );
  return res;
};
export const getquotationlineupdateinfo = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.quotation}/${apiRoutes.lineupdateinfo}`,
    data
  );
  return res;
};
export const getquotationrequestrepricing = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.quotation}/${apiRoutes.requestrepricing}`,
    data
  );
  return res;
};
export const getquotationupdatequoteline = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.quotation}/${apiRoutes.updatequotationline}`,
    data
  );
  return res;
};
export const getquotationupdatequote = async (data) => {
  const res = await instance.put(
    `${url.packagingapiurl}${Cclmodule.quotation}/${apiRoutes.quotationupdate}`,
    data
  );
  return res;
};

export const getqlireport = async (payload) => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.qlireport}?${payload}`
  );
  return res;
};

export const GetAllBlendSheets = (sampleId, company_name) => {
  return instance
    .get(`${url.packagingapiurl}${apiRoutes.batchoutput}${apiRoutes.GetAllBlendSheets}/${sampleId}/${company_name}`)
    .then((res) => {
      return res;
    });
};
export const GetAllBlendSheetsBatchOutput = (gc_blend_sheet_id) => {
  return instance
    .get(`${url.packagingapiurl}${apiRoutes.batchoutput}${apiRoutes.getBlendBatchOutputs}/${gc_blend_sheet_id}`)
    .then((res) => {
      return res;
    });
};

export const getOrderDispatch = (sampleId) => {
  return instance
    .get(`${url.packagingapiurl}${apiRoutes.batchoutput}${apiRoutes.getOrderDispatchData}/${sampleId}`)
    .then((res) => {
      return res;
    });
};
export const GetAllQuoteGcList = (company_name) => {
  return instance
    .get(`${url.packagingapiurl}${Cclmodule.quote}/${Cclmodule.status}/${Cclmodule.InputCostRequestedGC}/${company_name}`)
    .then((res) => {
      return res;
    });
};

export const getBatchoutputRemarksviewpicklist = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${apiRoutes.batchoutput}/${apiRoutes.viewpicklist}`
  );
  return res;
};

export const getusersrefreshtoken = (data) => {
  return instance
    .post(`${url.packagingapiurl}${Cclmodule.users}/${apiRoutes.refreshtoken}`, data)
    .then((res) => {
      return res;
    });
};
export const getcreatenote = (data) => {
  return instance
    .post(`${url.packagingapiurl}${Cclmodule.attachment}/${apiRoutes.createnote}`, data)
    .then((res) => {
      return res;
    });
};
export const getretrivenotes = (record_id) => {
  return instance
    .get(`${url.packagingapiurl}${Cclmodule.attachment}/${apiRoutes.retrivenote}/${encodeURIComponent(record_id)}`)
    .then((res) => {
      return res;
    });
};
export const getcreateattachment = (data) => {
  return instance
    .post(`${url.packagingapiurl}${Cclmodule.attachment}/${apiRoutes.createAttachment}`, data)
    .then((res) => {
      return res;
    });
}
export const getcreateAuditlog = (data) => {
  return instance
    .post(`${url.packagingapiurl}${Cclmodule.attachment}/${apiRoutes.auditlog}`, data)
    .then((res) => {
      return res;
    });
}

export const getretriveAttachment = (record_id) => {
  return instance
    .get(`${url.packagingapiurl}${Cclmodule.attachment}/${apiRoutes.retrieveAttachment}/${encodeURIComponent(record_id)}`)
    .then((res) => {
      return res;
    });
};
export const getretriveAuditlog = (record_id) => {
  return instance
    .get(`${url.packagingapiurl}${Cclmodule.attachment}/${apiRoutes.retrieveAuditlog}/${encodeURIComponent(record_id)}`)
    .then((res) => {
      return res;
    });
};
// api call for quotation list
export const getquotationList = (data) => {
  return instance
    .post(`${url.packagingapiurl}${Cclmodule.quotation}/${apiRoutes.list}`, data)
    .then((res) => {
      return res;
    });
};

// get export/domestic category list
export const getCategoryList = () => {
  return instance
    .get(`${url.packagingapiurl}${Cclmodule.finishedGood}/${apiRoutes.categoryList}`)
    .then((res) => {
      return res;
    });
};

// production schedule list
export const getGcItems = async (payload) => {
  return instance
    .post(`${url.packagingapiurl}${Cclmodule.gc}/${apiRoutes.gcItemList}`, payload)
    .then((res) => {
      return res;
    });
};

// Fetch List of active financial years
export const getFinancialYears = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${Cclmodule.quotationDomestic}/${apiRoutes.activefinancialyears}`,
  )
  return res;
};

// list of Quater
export const getQuaterList = async() => {
  const res = await instance.get(
      `${url.packagingapiurl}${Cclmodule.quotationDomestic}/${apiRoutes.quarterlist}`
    )
      return res;
};

//Aroma list Api
export const getAromaList = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${apiRoutes.getAromasList}`
  );
  return res;
};

//ProductCategeory list Api
export const getProductCategeoryList = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${apiRoutes.PCList}`
  );
  return res;
};  

//product flavour list api
export const getProductFlavourList = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${apiRoutes.productFlavourList}`
  );
  return res;
};

// Product subtype List API
export const getProductSubTypeList = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${apiRoutes.productSubTypeList}`
  );
  return res;
};

// Product  List API
export const getProductsList = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${apiRoutes.productList}`
  );
  return res;
};

// params  List API
export const getParametersList = async () => {
  const res = await instance.get(
    `${url.packagingapiurl}${apiRoutes.parametersList}`
  );
  return res;
};

//delete customer-sample-Parameters
export const deleteSampleParameter = async (data) => {
  const res = await instance.delete(
    `${url.packagingapiurl}${apiRoutes.deleteCSParameter}`,{data}
  );
  return res;
};


// factory code picklist
export const getFactoryPickList = async() => {
  return instance
    .get(`${url.packagingapiurl}${apiRoutes.pickList}/${apiRoutes.factoryCode}`)
    .then((res) => {
      return res;
    });
};

// get packing unit list
export const getPackingUnitList = async () => {
  return await instance
    .get(`${url.packagingapiurl}${apiRoutes.order}/${apiRoutes.dispatch}/${apiRoutes.packingunits}`)
    .then((res) => {
      return res;
    });
};
export const getDispatchVehicles = (dispatchId) => {
  return instance
    .get(`${url.packagingapiurl}${Cclmodule.vendor}/${apiRoutes.dispatch}/${encodeURIComponent(dispatchId)}/vehicles`)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
// get entity list
export const getEntityList = async() => {
  return instance
    .get(`${url.packagingapiurl}${Cclmodule.gcblendsheet}/${apiRoutes.entityList}`)
    .then((res) => {
      return res;
    });
};

// get GC Item type list
export const getGCItemTypeList = () => {
  return instance
    .get(`${url.packagingapiurl}${Cclmodule.gc}/${apiRoutes.gcItemTypeList}`)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export const getTaxListByCompany = async (companyName) => {
  const res = await instance.get(
    `${url.packagingapiurl}${apiRoutes.PO}/${apiRoutes.getTaxList}/${companyName}`
  );
  return res;
}

// Power BI Admin APIs — all other Power BI endpoints live in
// screens/admin/PowerBI/Service.ts; this one stays here because Users/Home/home.js
// (outside the PowerBI feature folder) still calls it from apis.js.
// company: "CCL", "NCL" or "All" (every company).
export const getMyPowerBiReports = (company = "All") =>
  instance.get(`${url.packagingapiurl}power-bi/my-reports`, { params: { company } }).then((r) => r);
